import * as React from 'react';
import { SVGProps } from 'react';

const AstronautUpsellBanner = (props: SVGProps<SVGSVGElement>) => (
  <svg
    id="Layer_1"
    xmlns="http://www.w3.org/2000/svg"
    width="112"
    height="123"
    {...props}
  >
    <mask
      id="mask0_642_74874"
      style={{ maskType: 'alpha' }}
      width="112"
      height="123"
      x="0"
      y="0"
      maskUnits="userSpaceOnUse"
    >
      <path fill="#D9D9D9" d="M0 0H112V123H0z"></path>
    </mask>
    <g mask="url(#mask0_642_74874)">
      <path
        fill="#FFD100"
        d="M94.18 17.334l-.35-.994a.84.84 0 01.341-.994l9.316-6.006a.847.847 0 011.282.508l.972 3.927a.847.847 0 01-.573 1.015l-9.937 3.078a.846.846 0 01-1.05-.53v-.005zM95.952 21.373l5.139.525a.847.847 0 01.731 1.073l-.485 1.75a.852.852 0 01-1.108.574l-4.894-1.769a.847.847 0 01-.477-1.164l.245-.512a.842.842 0 01.854-.477h-.005zM90.678 13.459a.85.85 0 01-.565-1.025l1.41-5.454a.845.845 0 011.077-.595l2.11.665a.849.849 0 01.429 1.313l-3.524 4.79a.848.848 0 01-.941.306h.004z"
      ></path>
      <path
        fill="#1F93CB"
        d="M83.526 30.39L82.2 21.98a2.223 2.223 0 011.847-2.543c1.213-.193 2.21.67 2.543 1.847.745 2.636 1.182 5.385 1.327 8.41.057 1.225-.635 2.35-1.848 2.543a2.222 2.222 0 01-2.543-1.847z"
      ></path>
      <path
        stroke="#42A9DB"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="7.931"
        d="M91.98 133.096L76.887 95.567"
      ></path>
      <path
        stroke="#F1F1F1"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="10.372"
        d="M76.887 95.567l10.847 26.782"
      ></path>
      <path
        fill="#F1F1F1"
        d="M93.753 120.61l-11.69 4.455c-.57.217-.856.855-.639 1.424l1.47 3.857c.217.57.854.855 1.424.638l11.69-4.455c.57-.217.855-.854.639-1.423l-1.47-3.858a1.103 1.103 0 00-1.424-.638z"
      ></path>
      <path
        stroke="#42A9DB"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="7.931"
        d="M60.031 138.625l.32-40.448"
      ></path>
      <path
        stroke="#F1F1F1"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="10.372"
        d="M60.349 98.177l-.298 28.896"
      ></path>
      <path
        fill="#42A9DB"
        d="M56.9 58.643c16.044 0 29.05-13.006 29.05-29.049S72.944.544 56.9.544c-16.043 0-29.048 13.007-29.048 29.05s13.005 29.05 29.049 29.05z"
      ></path>
      <path
        fill="#AC5E27"
        d="M57.012 12.982l-2.062.324c-9.04 1.427-15.452 8.794-14.03 17.83l1.261 8.085a2.678 2.678 0 003.064 2.228l29.632-4.675a2.678 2.678 0 002.228-3.065l-1.073-6.894c-1.427-9.04-9.985-15.265-19.024-13.842l.004.009z"
      ></path>
      <path
        fill="#EFAA83"
        d="M79.557 37.377a5.472 5.472 0 11-10.825 1.607 5.47 5.47 0 1110.821-1.607"
      ></path>
      <path
        fill="#E19B7C"
        d="M66.432 50.295l-8.877 1.401 1.186 7.512h.017-.013c.329 2.07 2.364 3.467 4.549 3.121l.963-.153c2.184-.346 3.694-2.303 3.366-4.369v-.004l-1.186-7.512-.005.004z"
      ></path>
      <path
        fill="#EFAA83"
        d="M74.402 27.299l1.633 10.335a15.458 15.458 0 01.07 4.325c-.836 6.584-5.923 12.1-12.805 13.185l-1.339.21c-8.352 1.318-16.192-4.386-17.51-12.738L42.818 32.28c-1.317-8.353 4.386-16.193 12.739-17.51l1.34-.21c8.352-1.318 16.192 4.386 17.51 12.738h-.005z"
      ></path>
      <path
        fill="#C8886D"
        d="M62.257 38.443l-2.206.348a.867.867 0 00-.72.99l.113.719a.867.867 0 00.991.72l2.205-.347a.867.867 0 00.721-.992l-.113-.717a.867.867 0 00-.991-.721z"
      ></path>
      <path
        fill="#7F1917"
        d="M67.724 41.926c.275-.043.52.18.499.46-.184 2.859-2.544 5.358-5.765 5.866-3.222.508-6.234-1.143-7.293-3.809a.435.435 0 01.337-.59l12.217-1.927h.005z"
      ></path>
      <mask
        id="mask1_642_74874"
        style={{ maskType: 'luminance' }}
        width="14"
        height="8"
        x="55"
        y="41"
        maskUnits="userSpaceOnUse"
      >
        <path
          fill="#fff"
          d="M67.724 41.926c.275-.043.52.18.499.46-.184 2.859-2.544 5.358-5.765 5.866-3.222.508-6.234-1.143-7.293-3.809a.435.435 0 01.337-.59l12.217-1.927h.005z"
        ></path>
      </mask>
      <g mask="url(#mask1_642_74874)">
        <path
          fill="#fff"
          d="M66.234 43.853l-8.721 1.377a.947.947 0 01-1.082-.787l-.112-.713 10.589-1.672.112.714a.947.947 0 01-.786 1.081z"
        ></path>
        <path
          fill="#D47E79"
          d="M63.323 53.648c2.142-.338 3.63-2.19 3.322-4.137-.307-1.946-2.292-3.25-4.434-2.911-2.142.338-3.63 2.19-3.323 4.136.308 1.946 2.293 3.25 4.435 2.912z"
        ></path>
      </g>
      <path
        stroke="#231F20"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="0.925"
        d="M53.043 38.345c.035-1.38 2.56-2.176 3.331-.442M65.813 36.59c.034-1.379 2.56-2.176 3.33-.442"
      ></path>
      <path
        fill="#C98A6D"
        d="M75.27 39.653c0 .648-.04 1.291-.118 1.921-.302.28-.723.49-1.209.565-1.068.166-2.035-.363-2.167-1.182-.13-.818.63-1.62 1.699-1.79.718-.114 1.392.087 1.795.486z"
        opacity="0.4"
      ></path>
      <path
        fill="#EFAA83"
        d="M50.978 41.973a5.47 5.47 0 01-10.82 1.602 5.47 5.47 0 0110.82-1.602z"
      ></path>
      <path
        fill="#C98A6D"
        d="M50.092 45.895c1.068-.169 1.828-.97 1.7-1.789-.13-.819-1.1-1.346-2.168-1.178-1.067.169-1.828.97-1.699 1.789.13.819 1.1 1.346 2.167 1.178z"
        opacity="0.4"
      ></path>
      <path
        fill="#AC5E27"
        d="M44.483 41.478l1.029-.162a1.326 1.326 0 001.103-1.514L44.837 28.53l-2.735.433 1.921 12.183c.035.219.241.367.46.337v-.005z"
      ></path>
      <path
        fill="#E4E4E4"
        d="M67.309 103.77c8.358 0 15.133-6.775 15.133-15.133 0-8.358-6.775-15.133-15.133-15.133-8.358 0-15.133 6.775-15.133 15.133 0 8.358 6.775 15.133 15.133 15.133zM72.724 67.994a5.669 5.669 0 100-11.338 5.669 5.669 0 000 11.338zM54.052 70.938a5.669 5.669 0 100-11.337 5.669 5.669 0 000 11.337z"
      ></path>
      <path
        fill="#E4E4E4"
        d="M60.349 104.974a6.798 6.798 0 100-13.596 6.798 6.798 0 000 13.596zM76.888 102.365a6.799 6.799 0 100-13.597 6.799 6.799 0 000 13.597z"
      ></path>
      <path
        stroke="#F1F1F1"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="8.541"
        d="M72.723 62.323l15.474.035 5.835-10.44"
      ></path>
      <path
        fill="#F1F1F1"
        d="M48.412 66.3c1.738 11.022 4.141 26.225 4.141 26.225l29.986-4.732s-2.412-15.238-4.146-26.238a5.876 5.876 0 00-6.723-4.89c-5.332.845-13.054 2.066-18.368 2.907a5.883 5.883 0 00-4.89 6.724v.004zM83.608 94.543l-1.064-6.75-29.985 4.732 1.05 6.658a6.85 6.85 0 007.836 5.7l16.542-2.609a6.763 6.763 0 005.626-7.73h-.005z"
      ></path>
      <path
        fill="#AC5E27"
        d="M42.217 23.37c.972-2.347 2.434-4.124 4.001-5.744 2.224-2.105 5.372-3.79 8.493-4.281l2.11-.333c5.704-.897 10.852.998 14.354 4.44 3.283 3.22 4.325 6.675 4.977 10.085l.052.341-2.582.407a6.48 6.48 0 01-7.412-5.393l.01.057a6.421 6.421 0 01-5.346 7.346l-19.593 3.09-.189-1.204c-.512-3.208.088-6.312 1.13-8.816l-.005.004z"
      ></path>
      <path
        stroke="#AC5E27"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.367"
        d="M49.466 12.14a4.647 4.647 0 00-1.742 6.34 4.651 4.651 0 00-4.439-2.334"
      ></path>
      <path
        stroke="#fff"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2.289"
        d="M41.805 14.44A18.622 18.622 0 0152.81 8.445M37.16 24.779c.136-1.178.381-2.333.727-3.445a18.45 18.45 0 011.2-2.938"
        opacity="0.3"
      ></path>
      <path
        fill="#fff"
        d="M58.5 56.139c14.492 0 26.24-11.748 26.24-26.24 0-14.49-11.748-26.238-26.24-26.238-14.49 0-26.238 11.748-26.238 26.239 0 14.491 11.747 26.239 26.239 26.239z"
        opacity="0.3"
      ></path>
      <path
        fill="#1F93CB"
        d="M31.24 38.697l-1.327-8.406a2.224 2.224 0 10-4.393.693l1.327 8.406a2.224 2.224 0 004.393-.693zM52.479 56.58l19.112-3.017a1.252 1.252 0 011.432 1.042l.09.566a1.252 1.252 0 01-1.042 1.432l-18.546 2.928a1.827 1.827 0 01-2.088-1.519 1.252 1.252 0 011.042-1.432z"
      ></path>
      <path
        fill="#26A4DC"
        d="M94.002 50.187c.762-.324 1.104-1.226.766-2.018l-2.166-5.109c-.338-.792-1.226-1.173-1.983-.849-.762.324-1.104 1.226-.766 2.018l2.166 5.109c.337.792 1.226 1.173 1.983.849z"
      ></path>
      <path
        fill="#26A4DC"
        d="M95.619 41.208l-2.787 3.33a4.784 4.784 0 107.336 6.138l2.786-3.33a4.783 4.783 0 10-7.335-6.138z"
      ></path>
      <path
        stroke="#F1F1F1"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="8.687"
        d="M54.05 65.271l-14.551 7.31-11.347-6.82"
      ></path>
      <path
        fill="#26A4DC"
        d="M22.38 56.9a4.784 4.784 0 10-4.203 8.592l3.9 1.909a4.783 4.783 0 104.204-8.592l-3.9-1.908zM82.247 85.713L52.34 91.036c-2.102.377-.937 6.904 1.164 6.532l29.907-5.323c.368-.066.547-.399.556-.753.048-1.773-.219-3.787-.941-5.266-.158-.32-.412-.578-.78-.513z"
      ></path>
      <path
        fill="#58B4E1"
        d="M74.056 94.822l-4.07.727c-1.069.193-2.097-.547-2.294-1.655l-.749-4.18c-.197-1.103.512-2.154 1.58-2.346l4.071-.727c1.069-.193 1.97.582 2.294 1.654.451 1.476.744 2.785.749 4.181 0 1.12-.512 2.154-1.58 2.346z"
      ></path>
      <path
        fill="#353584"
        d="M30.92 56.31L14.183 70.44c-1.094.924-2.732.767-3.664-.35L1.275 59.006c-.928-1.116-.797-2.766.293-3.69l16.735-14.13c1.095-.924 2.732-.766 3.664.35l9.245 11.084c.929 1.116.797 2.766-.293 3.69z"
      ></path>
      <path
        fill="#3F3A94"
        d="M31.864 55.522L15.13 69.653c-1.094.924-2.731.766-3.664-.35L2.22 58.219c-.928-1.116-.797-2.767.293-3.69l16.736-14.13c1.094-.925 2.731-.767 3.664.35l9.245 11.083c.928 1.116.797 2.767-.294 3.69z"
      ></path>
      <path
        fill="#D7EEF8"
        d="M30.04 55.333L15.262 67.81a2.266 2.266 0 01-3.205-.271l-8.002-9.596a2.298 2.298 0 01.29-3.222l14.778-12.475a2.267 2.267 0 013.204.27l8.002 9.596a2.298 2.298 0 01-.289 3.222z"
      ></path>
      <path
        fill="#F4B268"
        d="M14.39 58.931l7.033-5.993a1.172 1.172 0 10-1.518-1.783l-7.035 5.993a1.172 1.172 0 101.52 1.783z"
      ></path>
      <path
        fill="#26A7DF"
        d="M20.383 45.291l.227-.192-.192-.228a.177.177 0 01.017-.245.178.178 0 01.245.018l.193.227.228-.193a.177.177 0 01.245.018.178.178 0 01-.018.245l-.227.193.192.227a.177.177 0 01-.017.245.178.178 0 01-.245-.017l-.193-.228-.228.193a.177.177 0 01-.245-.018.178.178 0 01.018-.245z"
        opacity="0.4"
      ></path>
      <path
        fill="#3F3A93"
        d="M12.45 64.138l.284-.24-.241-.285a.216.216 0 01.026-.307.216.216 0 01.307.026l.24.285.285-.24a.216.216 0 01.306.025.216.216 0 01-.026.307l-.284.24.24.285a.216.216 0 01-.026.307.216.216 0 01-.306-.027l-.241-.284-.285.24a.216.216 0 01-.306-.026.216.216 0 01.026-.306zM19.883 59.616l.284-.24-.24-.285a.216.216 0 01.026-.307.216.216 0 01.306.026l.24.285.286-.24a.216.216 0 01.306.026.216.216 0 01-.026.306l-.285.24.24.285a.216.216 0 01-.025.307.216.216 0 01-.307-.027l-.24-.284-.285.24a.216.216 0 01-.307-.026.216.216 0 01.027-.306zM15.212 53.014a.84.84 0 100-1.681.84.84 0 000 1.68z"
        opacity="0.4"
      ></path>
      <path
        fill="#26A7DF"
        d="M26.868 54.09a.84.84 0 100-1.68.84.84 0 000 1.68zM7.67 56.407a.6.6 0 100-1.2.6.6 0 000 1.2z"
        opacity="0.4"
      ></path>
      <path
        fill="#fff"
        d="M6.54 52.87l15.692 9.056 4.076-3.436L10.61 49.43l-4.07 3.44zM3.582 57.093l14.48 8.357 2.71-2.285-15.697-9.057-.753.635a2.296 2.296 0 00-.74 2.35zM13.395 47.078l15.697 9.057.924-.784c.626-.53.902-1.318.797-2.075l-14.709-8.488-2.71 2.285v.005z"
        opacity="0.2"
      ></path>
      <path
        fill="#26A4DC"
        d="M27.527 64.232c-.854.07-1.603-.59-1.677-1.48l-.438-5.174c-.074-.888.556-1.667 1.405-1.738.854-.07 1.603.591 1.677 1.48l.438 5.174c.074.889-.556 1.668-1.405 1.738z"
      ></path>
    </g>
  </svg>
);

export default AstronautUpsellBanner;
